import React, { createContext, useReducer, useContext } from "react";

const initialState = {
    query: "",
    lastQuery: "",
};

function searchReducer(state, action) {
    switch (action.type) {
        case "SET_QUERY": {
            const newQuery = action.payload;
            const shouldSaveToLast = newQuery.length >= 3;

            return {
                ...state,
                lastQuery: shouldSaveToLast ? newQuery : state.lastQuery,
                query: newQuery,
            };
        }
        case "CLEAR_QUERY":
            return { query: "", lastQuery: "" };
        default:
            return state;
    }
}

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
    const [state, dispatch] = useReducer(searchReducer, initialState);
    return (
        <SearchContext.Provider value={{ state, dispatch }}>
            {children}
        </SearchContext.Provider>
    );
};

const useSearch = () => {
    return useContext(SearchContext);
};

export default useSearch;